export enum PromoBlockTextColor {
    white = 'white',
    black = 'black',
}

export enum PromoBlockBgColor {
    blue = 'blue',
    lightBlue = 'lightBlue',
    lightRed = 'lightRed',
}

export enum PromoBlockButtonColor {
    black = 'black',
    gray = 'gray',
    red = 'red',
    white = 'white',
}

export const enum PromoBlockId {
    AUTOUPLOAD = 'AUTOUPLOAD_PROMO_BLOCK',
    AUTOUPLOAD_LANDING = 'AUTOUPLOAD_ON_LANDING',
    PRE_OVERQUOTA = 'PRE_OVERQUOTA',
}

export interface PromoBlockBase {
    id: PromoBlockId;
    title: string;
    text: string;
    textColor: PromoBlockTextColor;
    buttonText: string;
    buttonColor: PromoBlockButtonColor;
    backgroundColor: PromoBlockBgColor;
    image: string | undefined;
    imageFullHeight?: boolean;
    analyticsName: string;
    showOnce?: boolean;
    closable?: boolean;
    buttonSecondaryText?: string;
    buttonSecondaryColor?: PromoBlockButtonColor;
    secondaryButtonAsLink?: boolean;
}

export interface PromoBlockProps extends PromoBlockBase {
    onClick: () => void;
    onSecondaryClick?: () => void;
    onClose?: () => void;
    onShow?: () => void;
    buttonDisabled?: boolean;
}
